import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { formatPercentage } from '@/localization/percentages';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';

type Props = ModalProps<{ monthlyRate: number }>;

const PaymentProtectionInsuranceReactivateSuccess = ({ payload, closeModal }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('PaymentProtectionInsuranceReactivateSuccess.title')}>
      <DataList>
        <DataListItem>
          <DataListLabel>{t('PaymentProtectionInsuranceReactivateSuccess.monthlyCost')}</DataListLabel>
          <DataListValue>{formatPercentage(payload.monthlyRate, { decimals: 1 })}</DataListValue>
        </DataListItem>
      </DataList>

      <ModalActions>
        <Button onClick={closeModal}>{t('PaymentProtectionInsuranceReactivateSuccess.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default PaymentProtectionInsuranceReactivateSuccess;
